import { createLazyComponent } from '@muse-web/router'

export const AsyncLinkAudacityIntentContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'link-audacity-intent' */ './LinkAudacityIntentContainer'),
    'LinkAudacityIntentContainer',
)
